export class TypeSecurityReference {
    static EPS = 0;
    static AFP = 1;
    static ARL = 2;
}